var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79167 7.36111C4.79167 4.36637 7.08938 1.875 10 1.875C12.9106 1.875 15.2083 4.36637 15.2083 7.36111C15.2083 8.4462 14.6089 9.72873 13.9228 10.8699C13.218 12.0422 12.3445 13.1877 11.6568 14.0305C10.7926 15.0898 9.2074 15.0898 8.34316 14.0305C7.65549 13.1877 6.78198 12.0422 6.07717 10.8699C5.39106 9.72873 4.79167 8.4462 4.79167 7.36111ZM8.125 7.08333C8.125 6.0478 8.96447 5.20833 10 5.20833C11.0355 5.20833 11.875 6.0478 11.875 7.08333C11.875 8.11887 11.0355 8.95833 10 8.95833C8.96447 8.95833 8.125 8.11887 8.125 7.08333Z",
    fill: "url(#paint0_linear_2509_2156)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60654 13.713C5.68982 14.048 5.48578 14.3871 5.1508 14.4703C4.41291 14.6538 3.85619 14.8689 3.49932 15.0859C3.19785 15.2692 3.13866 15.3887 3.12742 15.4169C3.13823 15.4444 3.19063 15.5463 3.43248 15.7052C3.73547 15.9042 4.2152 16.1074 4.86398 16.2876C6.15275 16.6456 7.96883 16.875 10 16.875C12.0312 16.875 13.8472 16.6456 15.136 16.2876C15.7848 16.1074 16.2645 15.9042 16.5675 15.7052C16.8094 15.5463 16.8618 15.4445 16.8726 15.4169C16.8613 15.3887 16.8022 15.2692 16.5007 15.0859C16.1438 14.8689 15.5871 14.6538 14.8492 14.4703C14.5142 14.3871 14.3102 14.048 14.3935 13.713C14.4767 13.378 14.8158 13.174 15.1508 13.2573C15.9473 13.4553 16.6406 13.7081 17.1501 14.0179C17.624 14.306 18.125 14.7612 18.125 15.4167C18.125 16.0298 17.6843 16.4672 17.2537 16.75C16.7976 17.0495 16.179 17.2952 15.4706 17.492C14.0449 17.888 12.111 18.125 10 18.125C7.88903 18.125 5.95511 17.888 4.52942 17.492C3.82097 17.2952 3.20235 17.0495 2.7463 16.75C2.31569 16.4672 1.875 16.0298 1.875 15.4167C1.875 14.7612 2.376 14.306 2.8499 14.0179C3.35944 13.7081 4.05272 13.4553 4.8492 13.2573C5.18418 13.174 5.52325 13.378 5.60654 13.713Z",
    fill: "url(#paint1_linear_2509_2156)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2509_2156",
    x1: 1.88667,
    y1: 9.99999,
    x2: 18.1367,
    y2: 9.99999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D802BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B7DB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2509_2156",
    x1: 1.88667,
    y1: 9.99999,
    x2: 18.1367,
    y2: 9.99999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D802BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B7DB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon_location.44a7a6daf659d70a59ceb88445f4e3a6.svg";
export { ForwardRef as ReactComponent };